package uk.co.nickthecoder.kyd.shapes

import org.khronos.webgl.Float32Array
import org.khronos.webgl.WebGLBuffer
import org.khronos.webgl.WebGLRenderingContext.Companion.ARRAY_BUFFER
import org.khronos.webgl.WebGLRenderingContext.Companion.STATIC_DRAW
import uk.co.nickthecoder.glok.application.Platform
import uk.co.nickthecoder.glok.backend.webgl.WebGLBackend
import uk.co.nickthecoder.glok.util.log

actual class MeshBuffer private constructor(data: Iterator<Float>, actual val floatCount: Int) {

    actual constructor(data: Collection<Float>) : this(data.iterator(), data.size)

    actual constructor(data: FloatArray) : this(data.iterator(), data.size)

    internal var vertexBuffer: WebGLBuffer? = WebGLBackend.gl.createBuffer()
        private set

    init {
        val float32Array = Float32Array(Array<Float>(floatCount) { data.next() })
        WebGLBackend.gl.bindBuffer(ARRAY_BUFFER, vertexBuffer)
        WebGLBackend.gl.bufferData(ARRAY_BUFFER, float32Array, STATIC_DRAW)
    }

    actual fun bind() {
        if (vertexBuffer == null) {
            log.error("Attempted to bind a MeshBuffer that has been deleted")
        }
        WebGLBackend.gl.bindBuffer(ARRAY_BUFFER, vertexBuffer)
    }

    actual fun delete() {
        vertexBuffer?.let {
            WebGLBackend.gl.deleteBuffer(it)
            vertexBuffer = null
        }
    }

    fun finalize() {
        val buffer = vertexBuffer
        if (buffer != null) {
            Platform.runLater { WebGLBackend.gl.deleteBuffer(buffer) }
        }
    }

    actual companion object {

        actual fun fromTriangles(triangles: Collection<Triangle>) =
            MeshBuffer(TriangleFloatIterator(triangles), triangles.size * 6)

    }

}
